import React, { useState } from 'react'
import Layout from 'components/layout/Layout';
import { InlineWidget } from "react-calendly"


export default function CalendlyMeet() {
  return (
    <div>
      <Layout headerStyle={2} footerStyle={2}>
        <div className="container mx-auto py-10 px-4 overflow-hidden text-center">
          <h1 className="text-3xl font-bold mb-4">Schedule a Meeting</h1>
          <p>Please select a date and time that works for you:</p>
          {/* Calendly widget */}
        <InlineWidget styles={{height:'90vh'}} url="https://calendly.com/mohit-editai/30min" />
        </div>
      </Layout>
    </div>
  )
}
